import { Button } from "../../../../core/components/atoms/Button";
import { Typography } from "../../../../core/components/molecules/Typography";
import { Modal } from "../../../../core/components/templates/Modal";

interface IModalOnCancel {
  message: string;
  isOpen: boolean;
  onClose: () => void;
}

export default function ModalOnError({ message, isOpen, onClose }: IModalOnCancel) {

  return (
    <Modal
        isOpen={isOpen}
        onClose={() => onClose()}
        position="center"
        className="p-0 w-[400px]"
      >
        <div className="flex flex-col gap-lg">
          <Typography>
            {message || "Erro ao enviar sua redação!"}
          </Typography>
          <div className="flex flex-row items-center justify-end gap-sm">
            <Button variant="text" onClick={() => onClose()}>
              Ok
            </Button>
          </div>
        </div>
      </Modal>
  )
}